// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__fUE1r","closeButton":"modal_closeButton__VJ96j","header":"modal_header__P07-3","title":"modal_title__F9OfK","BreakWords":"modal_BreakWords__USE-a"};